import React from "react";
import { ExpendableLink } from "./expendable-link";
import { DashboardIcon } from "../../components/icons";
import {
  Blocks,
  Cctv,
  Crosshair,
  LayoutDashboard,
  Package,
  RefreshCcw,
  ScanSearch,
  SendIcon,
  User,
} from "lucide-react";

export const AdminMenu: React.FC = () => {
  return (
    <>
      <ExpendableLink
        url="/"
        title="Dashboard"
        icon={<LayoutDashboard size={14} />}
      />

      <ExpendableLink
        title="Boutiques"
        url="/shops"
        icon={<Crosshair size={14} />}
      />

      <ExpendableLink
        title="Utilisateurs"
        url="/users"
        icon={<User size={14} />}
      />
    </>
  );
};
